import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categoryList } from '@/mocks/categories';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const isActive = (path: string) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/60'
          : 'bg-transparent'
      }`}
    >
      <div className="px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 group">
            <span className="text-2xl">🍉</span>
            <span className="text-lg font-bold text-foreground-950 font-heading whitespace-nowrap">
              吃瓜爆料网
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            <Link
              to="/"
              className={`px-4 py-2 text-sm font-medium rounded-lg transition-colors whitespace-nowrap ${
                isActive('/') && !isActive('/category') && !isActive('/about')
                  ? 'bg-primary-500 text-background-50'
                  : 'text-foreground-700 hover:text-foreground-950 hover:bg-background-100'
              }`}
            >
              首页
            </Link>
            {categoryList.map((cat) => (
              <Link
                key={cat.slug}
                to="/"
                className={`px-4 py-2 text-sm font-medium rounded-lg transition-colors whitespace-nowrap ${
                  isActive('/')
                    ? 'bg-primary-500 text-background-50'
                    : 'text-foreground-700 hover:text-foreground-950 hover:bg-background-100'
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`px-4 py-2 text-sm font-medium rounded-lg transition-colors whitespace-nowrap ${
                isActive('/about')
                  ? 'bg-primary-500 text-background-50'
                  : 'text-foreground-700 hover:text-foreground-950 hover:bg-background-100'
              }`}
            >
              关于我们
            </Link>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg text-foreground-700 hover:bg-background-100 cursor-pointer"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/60 py-2 px-4">
          <Link
            to="/"
            className={`block px-4 py-3 text-sm font-medium rounded-lg ${
              isActive('/') && !isActive('/category') && !isActive('/about')
                ? 'bg-primary-500 text-background-50'
                : 'text-foreground-700'
            }`}
          >
            首页
          </Link>
          {categoryList.map((cat) => (
            <Link
              key={cat.slug}
              to="/"
              className={`block px-4 py-3 text-sm font-medium rounded-lg ${
                isActive('/')
                  ? 'bg-primary-500 text-background-50'
                  : 'text-foreground-700'
              }`}
            >
              {cat.name}
            </Link>
          ))}
          <Link
            to="/about"
            className={`block px-4 py-3 text-sm font-medium rounded-lg ${
              isActive('/about')
                ? 'bg-primary-500 text-background-50'
                : 'text-foreground-700'
            }`}
          >
            关于我们
          </Link>
        </div>
      )}
    </nav>
  );
}